import {createSelector} from "@reduxjs/toolkit";

export const selectStoredFilters = createSelector(
  s => s, s => s.userInterface?.["accessControl.filters"] ?? {}
);
